import React, { forwardRef } from 'react'
import { Button } from '@ow/comps'
import { CircleCloseIcon } from '@ow/icons'

export default forwardRef(({ opts = {}, value, onChange }) => {
  const { multiple, selects } = opts
  const options = (selects || []).map((option) => {
    return { ...option, label: option.title }
  })
  const defaultValue = options
    .map((v) => v.slug)
    .filter((v) => {
      return opts.multiple ? value && value.includes(v) && v : v === value
    })

  const onSelect = (data = []) => {
    if (multiple) {
      onChange(data)
    } else {
      onChange((data && data[0]) || [])
    }
  }
  const onDelete = (slug) => {
    onSelect(defaultValue.filter((v) => v !== slug))
  }

  return (
    <div className="w-full h-full flex flex-row">
      <div className="whitespace-no-wrap mr-8 dark:text-dark-200">
        {opts.hint || opts.title}
      </div>
      <div className="flex flex-1 flex-wrap flex-row gap-1 items-center">
        <Button
          opacityType="transparent"
          style={{
            padding: '3.5px 16px',
            minWidth: '62px',
            color: defaultValue.length ? '' : '#fff',
            borderRadius: '14px',
            background: defaultValue.length
              ? 'transparent'
              : 'var(--ow-color-primary-700)',
          }}
          onClick={() => {
            onSelect([])
          }}
        >
          全部
        </Button>
        {selects.map((item) => {
          return (
            <div className="relative">
              <Button
                opacityType="transparent"
                style={{
                  borderRadius: '14px',
                  padding: '3.5px 16px',
                  color: defaultValue.includes(item.slug) ? '#fff' : '',
                  background: defaultValue.includes(item.slug)
                    ? 'var(--ow-color-primary-700)'
                    : 'transparent',
                }}
                onClick={() => {
                  onSelect(
                    multiple ? defaultValue.concat([item.slug]) : [item.slug]
                  )
                }}
              >
                {item.title}
              </Button>
              {defaultValue.includes(item.slug) && (
                <span
                  className="absolute -top-2 -right-2 cursor-pointer"
                  onClick={() => {
                    onDelete(item.slug)
                  }}
                >
                  <CircleCloseIcon
                    width="18px"
                    height="18px"
                    fill="rgb(var(--ow-bg-body-color))"
                  />
                </span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
})
